import { IconName } from '@klp/design/Illustrations';
import { SidebarMenuItem } from '@klp/layout/Sidebar/classes/SidebarMenuItem';
import { generateRoute } from '@klpkonsern/routing';
import { getRequiredConfig } from '@klpkonsern/appconfig';
import type { Bruker } from '@klp/user';
export const AreaKeyFiguresModuleName = 'areakeyfigures';

export const AreaKeyFiguresRoutes = {
    moduleRoute: () => generateRoute([AreaKeyFiguresModuleName]),
};

export const AreaKeyFiguresAccess = (user: Bruker | undefined): boolean =>
    Boolean(user && user.isAdmin);

export const AreaKeyFiguresMenuItems = [
    new SidebarMenuItem({
        route: AreaKeyFiguresRoutes.moduleRoute(),
        matchRoute: AreaKeyFiguresRoutes.moduleRoute(),
        icon: IconName.HOME,
        translation: 'keyfigures.areaTitle',
        access: AreaKeyFiguresAccess,
    }),
];

export const PowerBiAreaKeyFiguresURL = () =>
    getRequiredConfig('WEBAPP_POWER_BI_AREA_KEY_FIGURES_URL');
